import '../styles/Home.css';
import logo_load from '../assets/load.gif';
import logo_kdo from '../assets/logo-kdo.png';
import Partage from '../components/Partage';
import ListObject, { NO_LIST_ID } from '../components/ListObject';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Accueil from '../components/Accueil';
import AuthServices from '../services/AuthServices';
import listServices from "../services/listServices";
import sharedListServices from "../services/sharedListServices";
import { useState, useEffect } from 'react'
import Sidebar from '../components/Sidebar';

function Home({ p_user, p_key, p_setkey, p_isProprio, p_readonlyKey, p_roles, p_url = null, p_isReadOnlyView = false, p_sharedListId = null, p_sharedOwnerName = null }) {

  const [tabObject, settabObject] = useState([]);
  const [isDataLoading, setDataLoading] = useState(false)
  const [isDejaCharge, setIsDejaCharge] = useState(false)
  const [isError, setError] = useState(false)
  const [showSidebar, setShowSidebar] = useState(false);
  const [collapseControl, setCollapseControl] = useState(null);
  const [sharedLists, setSharedLists] = useState([]);
  const [listNames, setListNames] = useState({});
  const [selectedListId, setSelectedListId] = useState(null);

  const v_readOnlyLink = window.location.origin + '?key=' + p_readonlyKey;
  const isEditable = p_isProprio && !p_isReadOnlyView;
  const ownerKeyFromStorage = AuthServices.getConnectedKey();

  const ICON_COLORS = ['#EFF6FF', '#DCFCE7', '#FEF9C3', '#FEE2E2'];

  useEffect(() => {
    setShowSidebar(false);
  }, [p_user, p_key]);

  useEffect(() => {
    if (!ownerKeyFromStorage) {
      setSharedLists([]);
      return;
    }
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  }, [ownerKeyFromStorage]);

  console.log("Home p_roles : " + p_roles);

  async function fetchListNames() {
    const v_allName = await listServices.getAllListByKey(p_key);
    console.log(v_allName);
    const namesMap = {};
    for (const v_listInfos of v_allName) {
      namesMap[v_listInfos.id] = v_listInfos.name;
      console.log(v_listInfos);
    }
    setListNames(namesMap);
    console.log("fetchListNames", listNames);
  }

  useEffect(() => {
    if (tabObject.length === 0 && p_key && !isDataLoading && !isDejaCharge) {
      console.log("Initialisation chargement");
      fetchListNames();
      getListeObjectByUser(p_key);
    }
  }, [p_key, isDejaCharge]);

  function refreshListe() {
    fetchListNames();
    settabObject([]);
    setIsDejaCharge(false);
    getListeObjectByUser(p_key);
    console.log("refreshListe user : " + p_user);
  }

  async function addListe() {
    const v_newName = prompt("Nom de la nouvelle liste", "");
    if (v_newName) {
      await listServices.createRefList(p_key, v_newName);
      fetchListNames();
    }
  }

  async function getListeObjectByUser(p_key) {
    console.log("p_key: " + p_key)
    if (!p_key) {
      setError(true)
      setIsDejaCharge(true);
      console.log("p_key: " + p_key)
    }
    else {
      const requestOptions = {
        method: "GET",
        mode: 'cors',
        headers: { "Content-Type": "application/json" }
      };

      if (tabObject.length === 0 && !isDataLoading && !isDejaCharge) {
        setDataLoading(true)
        try {
          const timestamp = Date.now();
          const response = await fetch("https://app.listaki.fr/api/WS/getListObjectByKey.php?key=" + p_key + "&r=" + timestamp, requestOptions)
          if (response.ok) {
            const tabObjectresp = await response.json()
            settabObject(tabObjectresp);
            setError(false);
          } else {
            console.log("Erreur lors de l'appel à l'API");
            setError(true);
            setIsDejaCharge(true);
          }
          setIsDejaCharge(true);
        } catch (err) {
          console.log(err)
          setError(true)
          setIsDejaCharge(true);
        } finally {
          setDataLoading(false)
        }
      }
      else {
        console.log("tabObject deja chargé")
        console.log(tabObject)
      }
    }
  };

  function deconnexion() {
    AuthServices.logout(p_setkey);
    refreshListe();
  }

  const sharedListId = p_sharedListId || null;
  const sharedListKey = sharedListId || "all";
  const sharedOwnerLabel = p_sharedOwnerName ? `Listes de ${p_sharedOwnerName}` : "Listes partagees";
  const sharedListName = sharedListId ? (listNames?.[sharedListId] || "Liste partagee") : sharedOwnerLabel;
  const isSharedListSaved = sharedListServices.isSaved(ownerKeyFromStorage, p_key, sharedListKey);
  const canMemorizeSharedList = Boolean(p_isReadOnlyView && ownerKeyFromStorage);
  console.log("ownerKeyFromStorage:", ownerKeyFromStorage);

  const handleSaveSharedList = () => {
    if (!ownerKeyFromStorage || !p_key) return;
    sharedListServices.add({
      ownerKey: ownerKeyFromStorage,
      ownerName: p_sharedOwnerName || "",
      key: p_key,
      idList: sharedListKey,
      name: sharedListName,
      url: sharedListServices.buildUrl(p_key, sharedListKey)
    });
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  };

  const handleRemoveSharedList = (entry) => {
    if (!entry) return;
    sharedListServices.remove(ownerKeyFromStorage, entry.key, entry.idList);
    setSharedLists(sharedListServices.getAllForOwner(ownerKeyFromStorage));
  };

  const handleOpenSharedList = (entry) => {
    if (!entry?.key) return;
    const targetUrl = entry.url || sharedListServices.buildUrl(entry.key, entry.idList);
    window.location.assign(targetUrl);
  };

  const hasOrphans = tabObject.some(o => o.idList === null || o.idList === undefined);
  const listEntries = [...Object.entries(listNames), ...(hasOrphans ? [[NO_LIST_ID, 'Sans nom']] : [])];
  const hasLists = listEntries.length > 0;

  // Vue guest (non connecté)
  if (!p_user) {
    return (
      <div className="kdo-home">
        <Banner>
          <a href="https://listaki.fr"><img src={logo_kdo} alt='Mes Listes' className='kdo-ban-logo' /></a>
          <h1 className='kdo-ban-title'>LISTAKI : Crée ta liste !</h1>
        </Banner>
        <Accueil />
        <Footer />
      </div>
    );
  }

  // Vue liste partagée (lecture seule d'un autre user)
  if (p_isReadOnlyView) {
    return (
      <div className="kdo-home">
        <Banner>
          <a href="https://listaki.fr"><img src={logo_kdo} alt='Mes Listes' className='kdo-ban-logo' /></a>
          <div className='kdo-ban-title'>
            <h3>LISTAKI de {p_sharedOwnerName || p_user}</h3>
          </div>
        </Banner>
        {canMemorizeSharedList && (
          <div className="kdo-home-readonly-actions">
            <button className="kdo-home-button" onClick={handleSaveSharedList} disabled={isSharedListSaved}>
              {isSharedListSaved ? "Liste memorisee" : "Memoriser cette liste"}
            </button>
            <a href="/" className="kdo-home-button">
              Retour chez moi
            </a>
          </div>
        )}
        <div className="kdo-home-list-view">
          {tabObject.length === 0 && isDataLoading ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <img src={logo_load} alt='Chargement' />
              <p>Chargement...</p>
            </div>
          ) : isError ? (
            <p style={{ padding: 20 }}>Il y a eu une erreur, veuillez patienter quelques instants et recharger!</p>
          ) : (
            <ListObject
              p_key={p_key}
              p_tabObject={tabObject}
              p_setTabOject={settabObject}
              p_isProprio={isEditable}
              p_readonlyKey={p_readonlyKey}
              p_user={p_user}
              p_listNames={listNames}
              p_setListNames={setListNames}
              p_url={p_url}
              p_onGlobalCollapseChange={setCollapseControl}
              p_selectedListId={selectedListId}
              p_onBack={() => setSelectedListId(null)}
            />
          )}
        </div>
        <Footer />
      </div>
    );
  }

  // Vue liste sélectionnée (detail d'une liste)
  if (selectedListId !== null) {
    return (
      <div className="kdo-home kdo-home--list-view">
        {showSidebar && (
          <Sidebar
            p_roles={p_roles}
            onClose={() => setShowSidebar(false)}
            onLogout={deconnexion}
            p_sharedLists={sharedLists}
            p_isProprio={Boolean(ownerKeyFromStorage)}
            onOpenSharedList={handleOpenSharedList}
            onRemoveSharedList={handleRemoveSharedList}
          />
        )}
        <div className="kdo-home-list-view">
          {tabObject.length === 0 && isDataLoading ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <img src={logo_load} alt='Chargement' />
              <p>Chargement...</p>
            </div>
          ) : isError ? (
            <p style={{ padding: 20 }}>Il y a eu une erreur, veuillez patienter quelques instants et recharger!</p>
          ) : (
            <ListObject
              p_key={p_key}
              p_tabObject={tabObject}
              p_setTabOject={settabObject}
              p_isProprio={isEditable}
              p_readonlyKey={p_readonlyKey}
              p_user={p_user}
              p_listNames={listNames}
              p_setListNames={setListNames}
              p_url={p_url}
              p_onGlobalCollapseChange={setCollapseControl}
              p_selectedListId={selectedListId}
              p_onBack={() => setSelectedListId(null)}
            />
          )}
        </div>
      </div>
    );
  }

  // Vue principale "Mes listes" (connecté, aucune liste sélectionnée)
  return (
    <div className="kdo-home">
      {showSidebar && (
        <Sidebar
          p_roles={p_roles}
          onClose={() => setShowSidebar(false)}
          onLogout={deconnexion}
          p_sharedLists={sharedLists}
          p_isProprio={Boolean(ownerKeyFromStorage)}
          onOpenSharedList={handleOpenSharedList}
          onRemoveSharedList={handleRemoveSharedList}
        />
      )}

      {/* Header plat */}
      <div className="kdo-home-header">
        <div className="kdo-home-header-brand">
          <a href="https://listaki.fr" aria-label="Listaki">
            <img src={logo_kdo} alt="Listaki" className="kdo-home-logo" />
          </a>
          <div className="kdo-home-header-left">
            <p className="kdo-home-greeting">Bonjour {p_user} 👋</p>
            <h1 className="kdo-home-title">Mes listes</h1>
          </div>
        </div>
        <div className="kdo-home-header-actions">
          {isEditable && p_readonlyKey && (
            <Partage
              p_link={v_readOnlyLink}
              p_buttonClassName="kdo-home-share-all"
              p_buttonLabel="Partager toutes mes listes"
              p_buttonContent={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
              }
            />
          )}
          <button
            type="button"
            className="kdo-home-avatar"
            onClick={() => setShowSidebar(true)}
            aria-label="Ouvrir le menu"
            aria-haspopup="dialog"
          >
            {p_user ? p_user[0].toUpperCase() : 'U'}
          </button>
        </div>
      </div>

      {/* Contenu */}
      <div className="kdo-home-cards">
        {isEditable && (
          <button
            className="kdo-home-new-list-cta"
            onClick={() => { if (window.umami) window.umami.track('add-Liste'); addListe(); }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
            Nouvelle liste
          </button>
        )}
        {tabObject.length === 0 && isDataLoading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <img src={logo_load} alt='Chargement' />
            <p>Chargement...</p>
          </div>
        ) : isError ? (
          <p>Il y a eu une erreur, veuillez patienter quelques instants et recharger!</p>
        ) : hasLists ? (
          listEntries.map(([idlist, name], index) => {
            const isNoList = idlist === NO_LIST_ID;
            const targetId = isNoList ? NO_LIST_ID : Number(idlist);
            const items = isNoList
              ? tabObject.filter(o => o.idList === null || o.idList === undefined)
              : tabObject.filter(o => o.idList === Number(idlist));
            const total = items.length;
            const reserved = items.filter(o => o.reservationid).length;
            const progress = total > 0 ? Math.round((reserved / total) * 100) : 0;
            const totalPrice = items.reduce((sum, o) => sum + (parseFloat(o.price) || 0), 0);
            const iconColor = ICON_COLORS[index % ICON_COLORS.length];
            const iconEmoji = '🎁';

            return (
              <div
                key={idlist}
                className="kdo-list-card"
                onClick={() => setSelectedListId(targetId)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setSelectedListId(targetId); }}
              >
                <div className="kdo-list-card-icon" style={{ background: iconColor }}>
                  {iconEmoji}
                </div>
                <div className="kdo-list-card-body">
                  <p className="kdo-list-card-name" style={{ marginBottom: 3 }}>{name}</p>
                  <p className="kdo-list-card-count">
                    {total} article{total !== 1 ? 's' : ''}
                    {totalPrice > 0 && ` · ${Math.round(totalPrice)} € total`}
                  </p>
                  <div className="kdo-list-card-progress">
                    <div
                      className="kdo-list-card-progress-fill"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                  {total > 0 && (
                    <p className="kdo-list-card-reserved">{reserved} sur {total} réservé{reserved !== 1 ? 's' : ''}</p>
                  )}
                </div>
                <span className="kdo-list-card-chevron">›</span>
              </div>
            );
          })
        ) : (
          <div className="kdo-home-empty">
            <div className="kdo-help-card" role="note">
              <div className="kdo-help-card__icon" aria-hidden="true">?</div>
              <div className="kdo-help-card__content">
                <p className="kdo-help-card__title">Besoin d'un coup de main ?</p>
                <p className="kdo-help-card__subtitle">Retrouver toute l'aide dans : Menu &gt; Aide.</p>
                <p className="kdo-help-card__subtitle">Créez votre première liste pour commencer !</p>
              </div>
            </div>
            {isEditable && (
              <button className="kdo-home-button" style={{ marginTop: 20 }} onClick={() => { if (window.umami) window.umami.track('add-Liste'); addListe(); }}>
                Créer une liste
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
